export default __webpack_public_path__ + "static/media/shark1.e4d0f5ec.jpg";